import {combineReducers} from "redux";
import unsubscribeReducer from "@store/reducers/unsubscribe";
import configReducer from "@store/reducers/config";

const rootReducer = combineReducers({
    config: configReducer,
    unsubscribe: unsubscribeReducer
})

export default rootReducer;